<template>
  <b-card class="p-1">
    <div class="returns-toolbar d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-1">
      <b-form-group class="returns-search w-100 mb-1 mb-md-0">
        <b-input-group size="sm">
          <b-form-input v-model="filter" type="search" placeholder="Wyszukaj zwrot" @input="debouncedSearch" />
          <b-input-group-append>
            <b-button :disabled="!filter" @click="clearSearch"> Wyczyść </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
      <b-button :to="{ name: 'returns-settings' }" variant="primary" size="sm" class="returns-settings-button">
        <feather-icon icon="SettingsIcon" size="14" class="mr-50" />
        <span>Ustawienia</span>
      </b-button>
    </div>

    <b-table responsive bordered striped hover :items="returns" :fields="fields" :busy="isLoading">
      <template #table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong> Wczytywanie...</strong>
        </div>
      </template>
      <template #cell(status)="row">
        {{ statusLabel(row.item.status) }}
      </template>
      <template #cell(actions)="row">
        <b-button :to="{ name: 'returns-show', params: { id: row.item.id } }" variant="primary" size="sm">
          Zobacz
        </b-button>
      </template>
    </b-table>

    <div class="mt-2 d-flex flex-column flex-md-row justify-content-between align-items-md-center">
      <span>Pokazuje {{ returns.length }} z {{ total }} rekordów</span>
      <b-pagination v-model="page" :total-rows="total" :per-page="perPage" class="mb-0" @change="handlePageChange" />
      <b-form-select v-model="perPage" :options="perPageOptions" size="sm" class="w-auto" @change="handlePerPageChange" />
    </div>
  </b-card>
</template>

<script>
import NotificationMixin from '@/mixins/NotificationMixin';
import { all } from '@/http/returns';

export default {
  mixins: [NotificationMixin],

  data() {
    return {
      returns: [],
      fields: [
        { key: 'id', label: 'ID', sortable: true },
        { key: 'order_id', label: 'Zamówienie', sortable: true },
        { key: 'full_name', label: 'Klient', sortable: true },
        { key: 'email', label: 'Email', sortable: true },
        { key: 'status', label: 'Status', sortable: true },
        { key: 'items_count', label: 'Produkty', sortable: true },
        { key: 'created_at', label: 'Data zgłoszenia', sortable: true },
        { key: 'actions', label: 'Akcje' },
      ],
      filter: '',
      isLoading: false,
      page: 1,
      perPage: 10,
      total: 0,
      perPageOptions: [10, 25, 50, 100],
      searchTimeout: null,
    };
  },

  mounted() {
    this.fetchReturns();
  },

  methods: {
    async fetchReturns() {
      try {
        this.isLoading = true;
        const { data } = await all({ page: this.page, perPage: this.perPage, query: this.filter });
        this.returns = data.data;
        this.total = data.meta.total;
        this.page = data.meta.current_page;
        this.perPage = data.meta.per_page;
      } catch (error) {
        this.showErrorNotification('Problem z pobraniem danych', 'Nie udało się pobrać listy zwrotów.');
      } finally {
        this.isLoading = false;
      }
    },
    debouncedSearch() {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.page = 1;
        this.fetchReturns();
      }, 500);
    },
    clearSearch() {
      this.filter = '';
      this.page = 1;
      this.fetchReturns();
    },
    handlePageChange(page) {
      this.page = page;
      this.fetchReturns();
    },
    handlePerPageChange() {
      this.page = 1;
      this.fetchReturns();
    },
    statusLabel(status) {
      return {
        new: 'Nowe',
        in_review: 'Rozpatrywane',
        accepted: 'Zaakceptowane',
        completed: 'Zakończone',
        rejected: 'Odrzucone',
      }[status] || status;
    },
  },
};
</script>

<style scoped>
.returns-toolbar {
  gap: 0.75rem;
}

.returns-search {
  flex: 1 1 auto;
}

.returns-settings-button {
  align-items: center;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 0.857rem;
  font-weight: 600;
  min-height: 31px;
}
</style>
